<div  #refElement class="container-fluid stdTheme" *ngIf="okToDisplayMenu"
        [ngStyle]="{margin: '0px', 'margin-top': '0px', width: '100%', padding: '0px'}" >
     
        <!--
    <app-ngx-scanner-v2 *ngIf="doSearchByBarCode"
        [callMethod]="callScan"
        [productIdx]="prodCurIdx"
        (dataOut)="readByScanCode($event)"
        >
    </app-ngx-scanner-v2>
    -->
    <mat-card  class="register-card stdTheme wkscard" layout="column" flex 
        style="padding: 0px; padding-right: 5px; padding-left: 5px; height: 100%;padding-bottom: 10px;overflow-x: hidden!important; overflow-y: hidden!important;">
        <mat-card-title style="text-align: center;" >
            <div class="flex-row row" style="margin: 0px; padding: 0px;">
                <div class="col-12  " *ngIf="applicationStock === 'movements'" style="display: flex;justify-content: center;">
                    {{ 'MOVEMENTS.TITLE' | translate }}  
                </div>

            </div>
            <div class="flex-row row" style="margin: 0px; padding: 0px; font-size: 15px">

                <div class="col-12" *ngIf="applicationStock === 'movements'" style="display: flex;justify-content: space-between;">
                    <mat-select id="warehouse" #warehouse panelClass="mdiselectcontent" ngDefaultControl
                        [(value)]="warehouseCur" class="warehousePanel"
                        (selectionChange)="warehouseChoice(warehouse.value)">
                        <mat-option class="selectOptionsTheme" *ngFor="let warehouseItem of wareHousesList"
                            [value]="warehouseItem.warehouseId"> {{warehouseItem.warehouseRef}}
                        </mat-option>
                    </mat-select>
                    <mat-select id="movements" #movements panelClass="mdiselectcontent" ngDefaultControl
                        class="warehousePanel" 
                        [(value)]="movementsCur" 
                        placeholder=" {{ 'MOVEMENTS.CHOICE_MOVEMENTS' | translate }}"
                        (selectionChange)="movementsChoice(movements.value)">
                        <mat-option class="selectOptionsTheme" *ngFor="let movementsItem of movementsList"
                            [value]="movementsItem.value"> {{movementsItem.label}}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
        </mat-card-title> 
        
        <mat-card-actions style="flex-direction: row;box-sizing: border-box;display: flex;margin-left: 0px;margin-right: 0px;" >       
            <button [disabled] = "!btnSearchByRef" mat-raised-button (click)="searchByRef()">
                <i class="fa fa-search" aria-hidden="true" style="font-size: 15px"></i>
            </button>
            <div fxFlex></div>
            <button [disabled]="!btnSearchByBarCode" mat-raised-button (click)="searchByBarCode()">
                <i class="fa fa-barcode" aria-hidden="true" style="font-size: 15px"></i>
            </button>
            <div fxFlex></div>
            <button [disabled] = "!btnCreateForm" mat-raised-button (click)="addProduct()">
                <i class="fa fa-plus" aria-hidden="true" style="font-size: 15px"></i>
            </button>
            <div fxFlex></div>
            <button [disabled] = "btnQuit" mat-raised-button (click)="logout()" title="{{ 'COMMUN.BUTTON.LOGOUT' | translate }}">
                <!--<i class="fas fa-sign-out" aria-hidden="true" style="font-size: 15px"></i>-->
                <mat-icon>exit_to_app</mat-icon>
            </button>
        </mat-card-actions>
        <mat-card-content class="stdTheme">
            <div *ngIf="doSearchByBarCode">
                <app-ct37 
                    (scannerEvent)="scannedResponse($event)">
                </app-ct37>
                <div class="flex-row row"  style="margin: 0px; ">
                    <div class="col-lg-12 col-xs-12  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: space-between;">
                        <button style="margin-left:10px; margin-right: 40px;" class="mat-raised-button buttonTheme" mat-dialog-close 
                            (click)="doCancelSearchByBarcode(); doCancelSearchByRef()">{{'COMMUN.BUTTON.CANCEL' | translate}}
                        </button>
                        <button [disabled]="!scannedCode" style="margin-left:10px; margin-right: 40px;" class="mat-raised-button buttonTheme" mat-dialog-close 
                            (click)="launchSearchBarcode(scannedCode)">{{'INVENTORY.BTN_STOCK' | translate}}
                        </button>
                    </div>
				</div>
            </div>
            <div *ngIf="doSearchByRef">
                <div class="flex-row row" style="margin: 0px; padding: 0px;">
                    <div class="col-lg-4 col-xs-4"  >
                        <div class="input-group">
                            <input  id="ref" class="form-control inputTheme" 
                                    type="text" name="ref" placeholder="{{ 'INVENTORY.ENTER_REF' | translate: {minCar: MIN_CAR} }}" 
                                    (keyup)="ctrlInputRef(ref.value)"
                                    #ref>
                            <!--
                            <div class="input-group-append inputTheme">
                                <div *ngIf="okToSearch" class="input-group-text inputTheme">
                                    <i class="fa fa-search" aria-hidden="true" 
                                            [disabled]="!okToSearch"
                                            style="font-size: 15px" 
                                            title="{{ 'INVENTORY.START_SEARCH' | translate }}" 
                                            (click)="launchSearchReferential(ref.value)">
                                    </i>
                                </div>         
                            </div> 
                            -->          
                        </div>
                    </div>
                </div>
                <div class="flex-row row"  style="margin: 0px; ">
                    <div class="col-lg-12 col-xs-12  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: space-between;">
                        <button style="margin-left:10px; margin-right: 40px;" class="mat-raised-button buttonTheme" mat-dialog-close 
                            (click)="doCancelSearchByRef(); doCancelSearchByBarcode()">{{'COMMUN.BUTTON.CANCEL' | translate}}
                        </button>
                        <button [disabled]="!okToSearch" style="margin-left:10px; margin-right: 40px;" class="mat-raised-button buttonTheme" mat-dialog-close 
                             (click)="launchSearchReferential(ref.value)">{{'INVENTORY.BTN_STOCK' | translate}}
                        </button>
                    </div>
				</div>
            </div>
            <div *ngIf="displayCreateForm">
                <ng-container  [ngTemplateOutlet]="createFormTemplate"  ></ng-container>
            </div>
            <div *ngIf="displayListProducts" >
                <div  *ngFor= "let productItem of listProducts; let productIdx=index; let c=count;let isLast=last">
                    <div  style="margin: 0px; padding: 0px;"  >
                        <div id="productCur_{{productIdx}}" #productCur_{{productIdx}} style="line-height: 30px;margin-left: 0px;margin-right: 0px;" >
                            
                            <div class="col-lg-9 col-xs-9"  >
                                <span *ngIf="productItem.isCollapsed" class="fa fa-chevron-down" style="font-size: 15px" aria-hidden="true"></span>
                                <span *ngIf="!productItem.isCollapsed" class="fa fa-chevron-up" style="font-size: 15px" aria-hidden="true"></span>
                                <span style="margin: 0px;" (click)="productItem.isCollapsed = !productItem.isCollapsed; readStockByRef(productIdx)">
                                    {{ productItem.paramPartsSupplies.brandRef }} <b>{{ productItem.paramPartsSupplies.paramLabel }}</b> </span>
                            </div>
                            <div class="col-lg-2 col-xs-2" style="padding-right: 0px;padding-left: 0px;">
    
                            </div>
        
                        </div>
                        <div  [ngbCollapse]="productItem.isCollapsed">
                            <div class="flex-row row" style="margin-left: 10px; margin-right: 10px;">
                                <div class="col-lg-3 col-6  " style="padding-left: 0px;padding-right: 0px;">
                                    {{ 'INVENTORY.STOCK_BARCODE' | translate }}
                                </div>
                                <div class="col-lg-2 col-5  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: end;">
                                    <span> {{ productItem.paramPartsSupplies.brandBarcode }}</span>
                                </div>
                                <div class="col-lg-1 col-1  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: end;">
                                    <button mat-button (click)="displayScanBarCode(productIdx)">
                                        <i class="fa fa-barcode" aria-hidden="true" style="font-size: 15px"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="flex-row row" style="margin-left: 10px; margin-right: 10px;">
                                <div class="col-lg-3 col-6  " style="padding-left: 0px;padding-right: 0px;">
                                    {{ 'INVENTORY.STOCK_VIRTUAL' | translate }}
                                </div>
                                <div class="col-lg-2 col-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: end;">
                                    <span>{{productItem.stockVirtual | formatNumber : ['quantity',numberFormat.locale,numberFormat.minDecimal, numberFormat.maxDecimal]}}</span>
                                </div>
                            </div>
                            
                                <!-- movements stocks -->
                            <div *ngIf="applicationStock === 'movements'"class="flex-row row" style="margin-left: 10px; margin-right: 10px;">
                                <div  class="col-lg-3 col-6  " style="padding-left: 0px;padding-right: 0px;">
                                    <a *ngIf="movementsCur === 'input'">
                                        {{ 'MOVEMENTS.INPUT_MOVEMENT' | translate }}
                                    </a>
                                    <a *ngIf="movementsCur === 'output'">
                                        {{ 'MOVEMENTS.OUTPUT_MOVEMENT' | translate }}
                                    </a>
                                </div>
                                <div  class="col-lg-2 col-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: end;">
                                    <input class="form-control inputTheme" name="stockMovement" #stockMovement [ngStyle]="{'text-align': numberFormat.justifNumbers}" 
                                        type="text"
                                        value="{{productItem.stockMovement | formatNumber : ['quantity',numberFormat.locale,numberFormat.minDecimal, numberFormat.maxDecimal]}}"
                                        matInput (keypress)="numberAndDotOnly($event)" (change)="setStockMovement(stockMovement.value, productIdx)"/> 
                                </div>
                            </div>
                            <div *ngIf="applicationStock === 'movements'"class="flex-row row" style="margin-left: 10px; margin-right: 10px;">
                                <div class="col-12" style="margin-top: 10px; padding-left: 0px;padding-right: 0px;display: flex;justify-content: end;">
                                    <button  [disabled]="!productItem.isOkToValid" class="mat-raised-button buttonTheme" 
                                         style="margin-bottom: 10px;" 
                                        (click)="updateProduct('movements', productIdx)" >{{'COMMUN.BUTTON.SUBMIT' | translate}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

</div>

<ng-template let-value="valueArg" #createFormTemplate>
    <div class="flex-row row"  style="margin: 0px; margin-top: 15px;">
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: center;">
            {{ 'INVENTORY.CREATEFORM.BRAND' | translate }}
        </div>
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: start;">
            <mat-select id="brandName" #brandName panelClass="mdiselectcontent" ngDefaultControl
                placeholder=" {{ 'INVENTORY.CREATEFORM.BRAND' | translate }}"
                (selectionChange)="createFormBrand(brandName.value)">
                <mat-option class="selectOptionsTheme" *ngFor="let brandCur of brandsList"
                    [value]="brandCur.brandName"> {{brandCur.brandName}}
                </mat-option>
            </mat-select>
        </div>
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: center;">
            {{ 'INVENTORY.CREATEFORM.REF' | translate }}
        </div>
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: start;">
            <input class="form-control inputTheme" name="ref" #ref  id="ref"
                (input)="onInputChangeRef('ref')"
                placeholder="{{ partsRules.partsRefMask }}" 
                type="text"  matInput (change)="createFormRef(ref.value)" /> 
        </div>
    </div>
    <div class="flex-row row"  style="margin: 0px; margin-top: 15px;">
    <!-- label -->
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: center;">
            {{ 'INVENTORY.CREATEFORM.LABEL' | translate }}
        </div>
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: start;">
            <input class="form-control inputTheme" name="label" #label id="label"
                placeholder="{{ partsRules.partsLabelMask }}"
                (input)="onInputChangeLabel('label')"
                type="text"  matInput (change)="createFormLabel(label.value)" /> 
        </div>
    <!-- unit -->

        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: center;">
            {{ 'INVENTORY.CREATEFORM.UNIT' | translate }}
        </div>
        <!-- value="{{createValues.quantity | formatNumber : ['quantity',numberFormat.locale,numberFormat.minDecimal, numberFormat.maxDecimal]}}" -->
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: start;">

            <select class="selectBox inputTheme" #paramUnit 
                (change)="createFormUnit(paramUnit.value)">
                <option *ngFor="let unitQuantity of unitsQuantity" 
                        [value]="unitQuantity.value"
                        >{{ unitQuantity.label }}
                </option>
            </select>
        </div>
    <!-- quantity -->
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: center;">
            {{ 'INVENTORY.CREATEFORM.QTY' | translate }}
        </div>
        <!-- value="{{createValues.quantity | formatNumber : ['quantity',numberFormat.locale,numberFormat.minDecimal, numberFormat.maxDecimal]}}" -->
        <div class="col-lg-1 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: start;">
            <input class="form-control inputTheme" name="quantity" #quantity [ngStyle]="{'text-align': numberFormat.justifNumbers}" 
                type="text"
                value="{{createValues.quantity | formatNumber : ['quantity',numberFormat.locale,numberFormat.minDecimal, numberFormat.maxDecimal]}}"
                matInput (keypress)="numberAndDotOnly($event); "
                (change)="createFormQty(quantity.value)" /> 
        </div>
    </div>
    <div class="flex-row row"  style="margin: 0px; ">
        <div class="col-lg-12 col-xs-12  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: space-between;">
            <button style="margin-left:10px; margin-right: 40px;" class="mat-raised-button buttonTheme" mat-dialog-close 
                (click)="doCancelCreateForm()">{{'COMMUN.BUTTON.CANCEL' | translate}}
            </button>
            <button  [disabled]="!okToCreate" class="mat-raised-button buttonTheme" 
                mat-dialog-close style="margin-bottom: 10px;" (click)="createProduct()" >{{'COMMUN.BUTTON.SUBMIT' | translate}}
            </button>
        </div>
    </div>
</ng-template>